import PropTypes from 'prop-types';
import React from 'react';

import config from '../../../config';

import { translate as t } from '../../../lib/I18n';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import ExternalLink from '../../general/ExternalLink';

function KeyGoInformation ({ enableKeyGoMinTopup, children }) {
    const topUpMessage = enableKeyGoMinTopup ? (
        <p>{ t('account.smartcard.keygo.routes') }</p>
    ) : (
        <React.Fragment>
            <p>{ t('account.smartcard.keygo.details') }</p>
            <FormattedHTMLMessage
                message="account.smartcard.keygo.moreDetails"
                learnMoreLink={
                    <ExternalLink
                        message={ t('account.smartcard.keygo.moreDetails.link') }
                        href={ config.get('keyGoInformationUrl') }
                    />
                }
            />
        </React.Fragment>
    );

    return (
        <div className="margin-top">
            <div className="padding-bottom--sm border--bottom">
                { children }
                { topUpMessage }
            </div>
        </div>
    );
}

KeyGoInformation.propTypes = {
    children: PropTypes.any,
    enableKeyGoMinTopup: PropTypes.bool
};

export default KeyGoInformation;



// WEBPACK FOOTER //
// ./src/components/account/smartcard/KeyGoInformation.js